import React from 'react';
import { useStyles } from './SampleAssessmentStatistics.styles';
import ProcessStatistics from './ProcessStatistics.component';
import {
  ExamTaskGroupSolutionScoreStats,
  ExamTaskGroupSolutionScoreStatistic,
} from '../../../services/scoringModel/scoringModel.types';
import CircularProgress from '@mui/material/CircularProgress';

interface SampleAssessmentStatisticsProps {
  statData?: ExamTaskGroupSolutionScoreStats;
}

const SampleAssessmentStatistics: React.FC<SampleAssessmentStatisticsProps> = ({ statData }) => {
  const classes = useStyles();

  if (!statData)
    return (
      <div id="statisticsBar" className={classes.statHeader} style={{ justifyContent: 'center', padding: 10 }}>
        <div className={classes.control}>
          <CircularProgress />
        </div>
      </div>
    );

  return (
    <div id="statisticsBar" className={classes.statHeader}>
      {statData.statisticList.map((processData: ExamTaskGroupSolutionScoreStatistic) => (
        <div
          key={processData.processTypeId}
          className={classes.control}
          style={{ width: `${100 / statData.statisticList.length}%` }}
        >
          <ProcessStatistics {...processData} />
        </div>
      ))}
    </div>
  );
};

export default SampleAssessmentStatistics;
